import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";

import { CssBaseline, ThemeProvider } from "@mui/material";
import { ThemeProvider as ThemeProviderStyled } from "styled-components";
import Routes from "./routes";

import { theme, themeMUI } from "./styles/theme/default";
import GlobalStyles from "./styles/global";
import { PanelProvider } from "./contexts/PanelContext";
import { bootAudioPipeline } from "./services/audio/audioBootstrap";
import "./services/telemetry/telemetry";

function App() {
  useEffect(() => {
    bootAudioPipeline();
  }, []);

  return (
    <ThemeProvider theme={themeMUI}>
      <CssBaseline />
      <ThemeProviderStyled theme={theme}>
        <GlobalStyles />
        <PanelProvider>
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </PanelProvider>
      </ThemeProviderStyled>
    </ThemeProvider>
  );
}

export default App;
